import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { API } from "@/lib/api";
import { inr, num, pnlColor } from "@/lib/format";
import { BookOpen, Download } from "lucide-react";

export default function TradeJournal() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/journal").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const exportCsv = async () => {
    const token = localStorage.getItem("st_token");
    const res = await fetch(`${API}/journal/export`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "trade_journal.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  const totalPnl = rows.reduce((a, r) => a + (r.realized_pnl || 0), 0);

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold tracking-tight flex items-center gap-2"><BookOpen className="h-5 w-5 text-[#2563EB]" /> Trade Journal
          <span className={`ml-3 text-sm mono ${pnlColor(totalPnl)}`}>Net {inr(totalPnl)}</span>
        </h1>
        <button onClick={exportCsv} data-testid="journal-export" className="text-xs font-semibold px-3 py-1.5 rounded-sm bg-[#1A1D24] border border-[#2A2F3A] hover:bg-[#232730] flex items-center gap-1.5"><Download className="h-3.5 w-3.5" /> Export CSV</button>
      </div>

      <div className="term-panel rounded-sm overflow-auto">
        <table className="w-full text-xs">
          <thead className="bg-[#1A1D24] text-slate-400">
            <tr>{["Closed", "Symbol", "Strategy", "Buy", "Sell", "Lots", "Wavg Spread", "Exit Spread", "Realized P&L", "Reason"].map((h, i) => (
              <th key={h} className={`px-3 py-2 font-semibold whitespace-nowrap ${i >= 5 && i <= 8 ? "text-right" : "text-left"}`}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={10} className="px-4 py-8 text-center text-slate-600">No completed trades yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="gz-row">
                <td className="px-3 py-2 mono text-slate-500 whitespace-nowrap">{new Date(r.closed_at).toLocaleString()}</td>
                <td className="px-3 py-2 mono font-bold text-fg">{r.symbol}</td>
                <td className="px-3 py-2">{r.strategy_name}</td>
                <td className="px-3 py-2 mono text-[#5b9bff]">{r.buy_expiry}</td>
                <td className="px-3 py-2 mono text-[#FF6b62]">{r.sell_expiry}</td>
                <td className="px-3 py-2 mono text-right">{num(r.matched_lots, 0)}</td>
                <td className="px-3 py-2 mono text-right">₹{num(r.weighted_avg_spread, 2)}</td>
                <td className="px-3 py-2 mono text-right">₹{num(r.exit_spread, 2)}</td>
                <td className={`px-3 py-2 mono text-right font-semibold ${pnlColor(r.realized_pnl)}`}>{inr(r.realized_pnl)}</td>
                <td className="px-3 py-2 mono text-slate-400">{r.exit_reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-[10px] text-slate-600">Complete lifecycle records. Historical results do not guarantee future performance.</div>
    </div>
  );
}
